var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 31.2598C77 29.1394 77 28.0793 76.5807 27.5883C76.2169 27.1624 75.6711 26.9363 75.1127 26.9803C74.4691 27.0309 73.7194 27.7806 72.2201 29.2799L59.5 42L72.2201 54.7201C73.7194 56.2194 74.4691 56.9691 75.1127 57.0197C75.6711 57.0637 76.2169 56.8376 76.5807 56.4117C77 55.9207 77 54.8606 77 52.7402V31.2598Z",
    stroke: "#FEFEFE",
    strokeWidth: 4.34483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 34.3C7 28.4194 7 25.4792 8.14443 23.2331C9.1511 21.2574 10.7574 19.6511 12.7331 18.6444C14.9792 17.5 17.9194 17.5 23.8 17.5H42.7C48.5805 17.5 51.5208 17.5 53.7669 18.6444C55.7426 19.6511 57.3489 21.2574 58.3556 23.2331C59.5 25.4792 59.5 28.4194 59.5 34.3V49.7C59.5 55.5805 59.5 58.5208 58.3556 60.7669C57.3489 62.7426 55.7426 64.3489 53.7669 65.3556C51.5208 66.5 48.5805 66.5 42.7 66.5H23.8C17.9194 66.5 14.9792 66.5 12.7331 65.3556C10.7574 64.3489 9.1511 62.7426 8.14443 60.7669C7 58.5208 7 55.5805 7 49.7V34.3Z",
    stroke: "#FEFEFE",
    strokeWidth: 4.34483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.90a1b1de982366b88d0a8e23f0a31aa6.svg";
export { ForwardRef as ReactComponent };